<!-- eslint-disable no-unused-vars -->
<template>
    <div v-if="qrCodeLido == null">
        <div v-if="comandaSalva" class="qr-body">
            <br>
            <br>
            <br> 
            <h4>Quer ler outra comanda ou usar a comanda que ficou salva?</h4>
            <div class="div-comanda-salva">
                <button class="botao-mudar-comanda" @click="novaLeitura">Nova leitura</button>
                <button class="botao-confirmar-comanda" @click="confirmarNumeroSalvo(comandaSalva)">Usar {{ comandaSalva }}</button>
            </div>
        </div>
        <div v-if="!comandaSalva" class="qr-body"> 
            <br>            
            <div  v-if="!usarScanner && usarQrcodeScanner">
                <DemonstrativoLerComanda :imagem="require('../assets/ler-qr-code.png')" :texto="'Por favor, aponte a câmera para o QR Code do seu cartão de consumo.'"/>
                <br>
                <QrcodeScanner @onDetected="enviarTextoLido" />
            </div>
            <div class="qr-camera" v-if="usarScanner && !usarQrcodeScanner">
                <DemonstrativoLerComanda :imagem="require('../assets/ler-cod-barras.png')" :texto="'Por favor, aponte para o código de barras da sua comanda.'"/>
                <br>
                <barcode-quagga-component @onDetected="enviarTextoLido" />
            </div>

            <div class="qr-camera" v-if="!usarScanner && !usarQrcodeScanner">
                <p>Por favor, digite o número da sua comanda.</p>
                <br>
                <div>
                    <!-- <label for="">Comanda</label> -->
                    <input type="number" style="width: 80%; box-sizing: border-box; margin-inline: 10%;" placeholder="000000" v v-model="numeroDigitado">
                </div>
                <button v-if="podeEnviar" class="btn-enviar" @click="enviarTextoLido">Enviar</button>
                <button v-if="!podeEnviar" class="btn-enviar" style="background: grey; color: #111" >Enviar</button>
            </div>
            
        </div> 
    </div>
</template>

<script>
import BarcodeQuaggaComponent from './BarcodeQuaggaComponent.vue';
import QrcodeScanner from './QrcodeScanner.vue';
import DemonstrativoLerComanda from '@/components/Base/DemonstrativoLerComanda.vue';


export default {
    name: "CameraScanner",
    data() {
        return {
            qrCodeLido: null,
            videoDevicesRecog: null,
            videoElem: null,

            numeroDigitado: null,
            usarScanner: this.$store.state.cartaoComLeitorCodigoBarras ?? false,
            usarQrcodeScanner: this.$store.state.cartaoComQrCode ?? false,
            comandaSalva:sessionStorage.getItem('comanda-guardada-session'),
        }
    },

    mounted() {
        if (this.usarScanner)
        this.onCreate()
    },

    computed: {
        // usado apenas caso nao use Scanner
        podeEnviar() {
            if (this.usarScanner == false) {
                if (this.numeroDigitado != null && this.numeroDigitado.length > 0) {   
                    return true  
                } else {
                    return false
                }
            }
            return true;
        }
    },
    
    methods: {
        novaLeitura(){
            sessionStorage.setItem('comanda-guardada-session', '');
            this.comandaSalva=null;
        },
        confirmarNumeroSalvo(textoLido){
            this.$emit("onBarcodeLido", textoLido) 
        },
        enviarTextoLido(textoLido) {
            console.log("detect3ed here")
            console.log(textoLido)
            if (!this.usarScanner && this.usarQrcodeScanner) {
                sessionStorage.setItem('comanda-guardada-session', textoLido);
                this.$emit("onBarcodeLido", textoLido)  
            } else if (this.usarScanner && !this.usarQrcodeScanner) {
                sessionStorage.setItem('comanda-guardada-session', textoLido);
                // vamos setar essa var para sumir todos os elementos HTML
                this.qrCodeLido = textoLido
                // vamos mandar pro parent o qrcode ou barcode ligo
                this.$emit("onBarcodeLido", textoLido)     
            } else {
                if (this.numeroDigitado != null && this.numeroDigitado.length > 0) {  
                    sessionStorage.setItem('comanda-guardada-session', this.numeroDigitado); 
                    // vamos mandar pro parent o qrcode ou barcode ligo
                    this.$emit("onBarcodeLido", this.numeroDigitado)     
                }
            }
        },
        
    },
    components: {
        BarcodeQuaggaComponent, QrcodeScanner, DemonstrativoLerComanda
    }
}
</script>

<style scoped>
.qr-body {
    height: 100vh;
    /* margin-block: 15px; */
    background:white;
}
.div-comanda-salva{
    display: flex;
    padding: 15px;
    gap: 15px;
}
.botao-confirmar-comanda,.botao-mudar-comanda{
    height: 70px;
    width: 100%;
    font-weight: bold;
    border-radius: 5px;
}
.botao-mudar-comanda{
    background: var(--azul-claro);
}
.botao-confirmar-comanda{
    background: var(--verde-claro);
}
.btn-enviar {
    width: 80%; height: 40px; margin-top: 15px;
}
.qr-camera {
    width: 100vw; 
    height: 250px;
    position: relative;
}
.webcam-preview {
    width: 100vw;
    height: 100%;
    object-fit: cover;
}
.scan-bar-anim {
    position: absolute;
    width: 100%;
    margin-inline: 0%;
    height: 2px;
    top: 25px;
    background: red;
    animation: scan-bar-anim 3s infinite;
}
@keyframes scan-bar-anim {
    0%, 100% { top: 50px  }
    50%      { top: 190px }
}
</style>